import { computed } from 'vue'
import { useAccount } from '@/stores/account'

export function useFeatureFlag(flagName) {
  const account = useAccount()
  return computed(() => account.featureFlags?.includes(flagName) ?? false)
}
